module.exports = __webpack_public_path__ + "eae03c3f180a033f3ddd8fa9d170db02.svg";